var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[(_vm.crumbs)?_c('b-breadcrumb',{attrs:{"items":_vm.crumbs}}):_vm._e(),_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"page-description"},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }